goog.provide("shadow.js.shim.module$src$svg$controls$scope_svg");
goog.provide("module$shadow_js_shim_module$src$svg$controls$scope_svg");
shadow.js.shim.module$src$svg$controls$scope_svg = shadow.js.nativeProvides["src/svg/controls/scope.svg"] = shadow$bridge("src/svg/controls/scope.svg");
module$shadow_js_shim_module$src$svg$controls$scope_svg.default = shadow.js.shim.module$src$svg$controls$scope_svg;
